/* eslint-disable @repo/internal/react/require-jsdoc */

import React from 'react';

import { Footer, type FooterColumn, type FooterRowItem } from '@af/design-system-docs-ui';

const columns: FooterColumn[] = [
	{
		title: 'Design system',
		items: [
			{
				label: "What's new",
				href: '/whats-new',
			},
			{
				label: 'Get started',
				href: '/get-started',
			},
			{
				label: 'Foundations',
				href: '/foundations',
			},
			{
				label: 'Components',
				href: '/components',
			},
			{
				label: 'Patterns',
				href: '/patterns',
			},
			{
				label: 'Tools',
				href: '/tools',
			},
			{
				label: 'Release phases',
				href: '/release-phases',
			},
			{
				label: 'Contact us',
				href: '/contact-us',
			},
		],
	},
	{
		title: 'News',
		items: [
			{
				label: 'Featured',
				href: '/news#featured',
			},
			{
				label: 'Design blogs',
				href: '/news#design-blogs',
			},
			{
				label: 'Leadership talks',
				href: '/news#leadership-talks',
			},
			{
				label: 'Team stories',
				href: '/news#team-stories',
			},
		],
	},
	{
		title: 'Other libraries',
		items: [
			{
				label: 'Atlaskit',
				href: 'https://atlaskit.atlassian.com',
			},
			{
				label: 'Forge UI Kit',
				href: 'https://developer.atlassian.com/platform/forge/user-interface/',
			},
			{
				label: 'Brand kit',
				href: 'https://orangedam.atlassian.com/',
			},
		],
	},
	{
		title: 'Careers',
		items: [
			{
				label: 'Life at Atlassian',
				href: 'https://www.atlassian.com/company/careers',
			},
			{
				label: 'Design and content roles',
				href: 'https://www.atlassian.com/company/careers/all-jobs?team=Design',
			},
			{
				label: 'Developer roles',
				href: 'https://www.atlassian.com/company/careers/all-jobs?team=Engineering',
			},
			{
				label: 'Product roles',
				href: 'https://www.atlassian.com/company/careers/all-jobs?team=Product%20Management%2CProgram%20Management',
			},
		],
	},
];

const row: FooterRowItem[] = [
	{
		label: 'Trademark',
		href: 'https://www.atlassian.com/legal/trademark',
	},
	{
		label: 'Privacy',
		href: 'https://www.atlassian.com/legal/privacy-policy',
	},
	{
		label: 'License',
		href: '/license',
	},
];

export default ({ isHome }: { isHome: boolean }): React.JSX.Element => (
	<Footer isHome={isHome} columns={columns} row={row} />
);
